import { registerLocaleData } from '@angular/common';
import fr from '@angular/common/locales/fr';
import { Routes } from '@angular/router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { MaterialsGuard } from '@auth/materials.guard';
import { BalanceComponent } from '@components/balance/balance.component';
import { ConstructionSiteComponent } from '@components/construction-site/construction-site.component';
import { DashboardComponent } from '@components/dashboard/dashboard.component';
import { FilesComponent } from '@components/files/files.component';
import { GlobalMaterialsComponent } from '@components/materials/global-materials/global-materials.component';
import { OrdersMaterialsComponent } from '@components/materials/orders-materials/orders-materials.component';
import { QuotationComponent } from '@components/quotation/quotation.component';
import { QuotationsListComponent } from '@components/quotations-list/quotations-list.component';
import { ScheduleComponent } from '@components/schedule/schedule.component';
import { ShowroomsComponent } from '@components/showrooms/showrooms.component';
var appRoutes = [
    { path: 'projects/:pid/quotations', component: QuotationsListComponent },
    {
        path: 'projects/:pid/materials',
        component: GlobalMaterialsComponent,
        children: [
            {
                path: '',
                canActivateChild: [MaterialsGuard],
                children: [
                    { path: 'orders', component: OrdersMaterialsComponent }
                ]
            }
        ]
    },
    {
        path: 'quotations/:qid/versions/:vid',
        component: QuotationComponent
    },
    { path: '', component: DashboardComponent },
    { path: 'projects/:pid/dashboard', component: DashboardComponent },
    {
        path: 'projects/:pid',
        redirectTo: 'projects/:pid/dashboard',
        pathMatch: 'full'
    },
    { path: 'projects/:pid/files', component: FilesComponent },
    { path: 'projects/:pid/schedule', component: ScheduleComponent },
    { path: 'projects/:pid/showrooms', component: ShowroomsComponent },
    { path: 'projects/:pid/balance', component: BalanceComponent },
    { path: 'projects/:pid/chantier', component: ConstructionSiteComponent },
    { path: '**', redirectTo: 'projects/:pid/dashboard' }
];
registerLocaleData(fr, 'fr');
// Retrieve access token
export function tokenGetter() {
    return localStorage.getItem('access_token');
}
export var whiteRegex = [new RegExp('^.*$')];
export function jwtOptionsFactory() {
    return {
        tokenGetter: tokenGetter,
        whitelistedDomains: whiteRegex,
        blacklistedRoutes: ['http://picasaweb.google.com/data/entry/api/user/']
    };
}
var ɵ0 = createErrorHandler({
    showDialog: false
});
var AppModule = /** @class */ (function () {
    function AppModule(trace) {
        library.add(fal, fas, far, fad);
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
